import type { CollectionConfig } from '@/utils/collections/collections.types';

import SearchPageHeaderMeta from './components/SearchPageHeaderMeta/SearchPageHeaderMeta';
import SeoSearchPageHeaderMeta from './components/SeoSearchPageHeaderMeta/SeoSearchPageHeaderMeta';

type Props = {
    canonicalURL: string;
    /** Set on a /collections/<slug> page; supplies the title and description overrides. */
    collection?: CollectionConfig;
    displayLocation: string;
    displaySearchTerm: string;
    isSEOSearchPage: boolean;
    page: number;
    searchTerm: string;
    totalFound: number;
};

export const SearchPageHeaderMetaWrapper = ({
    canonicalURL,
    collection,
    displayLocation,
    displaySearchTerm,
    isSEOSearchPage,
    page,
    searchTerm,
    totalFound,
}: Props) => {
    return (
        <>
            {isSEOSearchPage || Boolean(collection) ? (
                <SeoSearchPageHeaderMeta
                    canonicalURL={canonicalURL}
                    collectionBreadcrumbs={collection?.breadcrumbs}
                    displayLocation={displayLocation}
                    displaySearchTerm={displaySearchTerm}
                    isCollectionPage={Boolean(collection)}
                    metaDescription={collection?.metaDescription}
                    seoTitle={collection?.seoTitle}
                    totalFound={totalFound}
                />
            ) : (
                <SearchPageHeaderMeta
                    page={page}
                    searchTerm={searchTerm}
                />
            )}
        </>
    );
};
